export const areAllAvailableSelected = (
  selected: any[],
  available: any[] | Record<string, unknown>
) => {
  if (!Array.isArray(available)) {
    // available is an object
    return selected.length === Object.keys(available).length
  }
  return selected.length === available.length
}
